import HowToFind from "../../components/HowToFind/HowToFind";
import Footer from "../../components/Footer/Footer";
import HowToUse from "../../components/HowToUse/HowToUse";
import CheckOccupancy from "../../components/check-occupancy/Reservation";
import NavBar from "../../components/NavBar/NavBar";



const Home = () => {
    return (
        <div id="home">
            <>
                <NavBar />
                <CheckOccupancy />
                <HowToFind />
                <HowToUse />
                <Footer />
            </>
        </div>
    );
}

export default Home;
